// fileUploader.js
import { toast } from "react-toastify";
import { addMedia } from "../slices/0-media/thunk";
import i18n from "../i18n";

export const handleFileUpload = async (dispatch, file, type, onSuccess) => {
  if (!file) return;

  // ✅ 5MB validation
  const maxSize = 5 * 1024 * 1024;

  if (file.size > maxSize) {
    toast.error(i18n.t("validation.fileTooLarge"), {
      autoClose: 3000,
    });
    return;
  }

  try {
    const resultAction = await dispatch(addMedia({ type, file }));

    if (addMedia.fulfilled.match(resultAction)) {
      const url = resultAction.payload?.data?.data?.[0]?.url;
      if (onSuccess) onSuccess(url);
    }
  } catch (error) {
    toast.error("Failed to upload file", { autoClose: 3000 });
    console.error(error);
  }
};
